/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddressV1Dto } from './AddressV1Dto';
import type { AreaV1Dto } from './AreaV1Dto';
import type { LocationToPartnerV1Dto } from './LocationToPartnerV1Dto';
export type LocationV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * The name of the location.
   */
  name: string;
  /**
   * The description of the location.
   */
  propertyDescription?: string | null;
  /**
   * The total area of the location in square meters.
   */
  totalArea?: number | null;
  /**
   * The start date of the location.
   */
  startDate?: string | null;
  /**
   * The type of the location.
   */
  type?: LocationV1Dto.type | null;
  /**
   * The address of the location.
   */
  addresses?: Array<AddressV1Dto> | null;
  /**
   * The areas of the location.
   */
  areas?: Array<AreaV1Dto> | null;
  /**
   * The partners of the location.
   */
  locationToPartners?: Array<LocationToPartnerV1Dto> | null;
};
export namespace LocationV1Dto {
  /**
   * The type of the location.
   */
  export enum type {
    COMMERCIAL_CENTRE = 'CommercialCentre',
    OUTLET = 'Outlet',
    OFFICE_BUILDING = 'OfficeBuilding',
    STANDALONE = 'Standalone',
    RETAIL_CENTER = 'RetailCenter',
    OTHER = 'Other',
    COMMERCIAL_BUILDING = 'CommercialBuilding',
    MEDICAL_FACILITY = 'MedicalFacility',
  }
}
